module.exports = __webpack_public_path__ + "static/media/2get.519784b7.svg";